// extracted by mini-css-extract-plugin
export default {"full-page-load":"Loading_full-page-load__+xBbC"};